import { ActionToolbarItem } from "./ActionToolbarItem"
import { FC } from "react";
import { IPageAction } from "../../../base/models";
import clsx from "clsx";

interface IPageToolbarActionsProps {
    actions?: IPageAction[];
    className?: string;
}

export const PageToolbarActions: FC<IPageToolbarActionsProps> = ({
    actions, className
}) => {
    if (!actions)
        return <></>

    return <div className={clsx(className, "d-flex flex-wrap gap-1")}>
        {actions.map((action, i) => (
            <ActionToolbarItem key={i} action={action} />
        ))}
    </div>
}